



















import { Component, Vue, Prop } from "vue-property-decorator";
import { Room } from "@/types";
import InstructionsBox from "@/components/InstructionsBox.vue";
import VideoParticipants from "@/components/room/VideoParticipants.vue";
import ShareLink from "@/components/room/ShareLink.vue";

import * as twilio from "twilio-video";

@Component({ components: { InstructionsBox, VideoParticipants, ShareLink } })
export default class VideoGridAlone extends Vue {
  @Prop({ required: true })
  room!: Room;

  @Prop({ required: true })
  myId!: string;

  @Prop({ required: true })
  participant!: twilio.LocalParticipant;
}
